import { render } from "./KotSyncModal.vue?vue&type=template&id=3492e1c3&scoped=true"
import script from "./KotSyncModal.vue?vue&type=script&lang=js"
export * from "./KotSyncModal.vue?vue&type=script&lang=js"

import "./KotSyncModal.vue?vue&type=style&index=0&id=3492e1c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3492e1c3"]])

export default __exports__